<template>
    <v-container fluid grid-list-md class="px-0 pt-0 map-asset-details-container scrollbar">      
      <v-layout column px-0 >
        
        <v-flex xs12 style="padding: 0px 0px;" >
          <v-card v-if="selectedAsset.mainImage" color="primary lighten-1" class="white--text asset-heading-image" :style="`background: url('${imageUrl}') no-repeat center center ;`">
            <div class="asset-details-close-button">                  
                <v-btn   fab color="accent "  @click="$emit('closedClicked')">
                    <v-icon>close</v-icon>
                </v-btn>
            </div>
            <div class="asset-image-info">                               
                <div primary-title>
                  <div>
                    <div ><i :class="`${asset.group.icon} fa-1x white--text mr-2`" style="opacity:0.8;"></i>{{asset.name}}</div>                    
                  </div>
                  <!-- <v-icon  @click="$emit('closedClicked')">close</v-icon> -->                                   
                </div>                            
            </div>
          </v-card>
          <v-card v-else color="primary lighten-1" class="white--text">
            <v-layout>
              <v-flex xs12 >
                <v-card-title primary-title>
                  <div >
                    <div class="headline">{{asset.name}}</div>
                    <div>Groep: <i>{{asset.group.name}}</i></div>
                    <div>Type:  <i>{{asset.type.name}}</i></div>
                  </div>
                  <!-- <v-icon  @click="$emit('closedClicked')">close</v-icon> -->
                  <v-spacer></v-spacer>
                  <v-flex >
                    
                    <v-btn  small fab color="primary darken-2"  @click="$emit('closedClicked')">
                        <v-icon>close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-card-title>
              </v-flex>
              <v-flex xs4 d-flex align-center justify-center>
                <i :class="`${asset.group.icon} fa-5x primary--text text--lighten-2`"></i>
                <!-- <font-awesome-icon icon="gas-pump" class="asset-icon" /> -->
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card color="primary lighten-2" class="white--text">
            <v-layout>
              <v-flex xs12 py-2 d-flex center>
                 <v-tooltip left>
                  <v-btn style="margin-left:0px" flat  color="primary" slot="activator" @click="$emit('focusCurrentClicked')">
                    <v-icon large >gps_fixed</v-icon>
                  </v-btn>
                  <span>Centreer op de kaart</span>
                </v-tooltip>
                <v-tooltip left>
                  <v-btn v-if="visibleForUser"  flat  color="primary" slot="activator" @click="$router.push(`/asset-details/${selectedAsset.id}`)">
                    <v-icon large >open_in_new</v-icon>
                  </v-btn>
                  <span>Ga naar pagina voor {{asset.name}}</span>
                </v-tooltip>
                <v-tooltip left >
                  <v-btn  v-if="visibleForUser" flat  color="primary" slot="activator" @click="createManualEventClicked(asset)">
                    <v-icon large >add_alert</v-icon>
                  </v-btn>
                  <span>Maak nieuw event aan voor {{asset.name}}</span>
                </v-tooltip>
                <v-tooltip left >
                  <v-btn v-if="visibleForUser" flat  color="primary" slot="activator" @click="showPOIWizard(asset)">
                    <v-icon large >flag</v-icon>
                  </v-btn>
                  <span>Stel point on interest in voor {{asset.name}}</span>
                </v-tooltip>
                <v-tooltip left >
                  <v-btn v-if="visibleForUser" flat  color="primary" slot="activator" @click="assetConfigurationClicked(asset)">
                    <v-icon large >settings</v-icon>
                  </v-btn>
                  <span>Open instellingen voor {{asset.name}}</span>
                </v-tooltip>       
                <v-tooltip left >
                  <v-btn  v-if="visibleForUser" flat color="primary" slot="activator" @click="openFavoritePannel(asset)">
                    <v-icon  large :class="favoriteClass" ></v-icon>
                  </v-btn>
                  <span>Klik om deze asset als favoriet in te stellen</span>
                </v-tooltip>                    
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card :color="assetStatusColor(selectedAsset)" class="white--text" >
            <v-layout>
              <v-flex xs12 px-4 py-2 d-flex center>
                <v-flex d-flex><i :class="`${statusToIconString(selectedAsset)} fa-2x`" ></i></v-flex>
                <v-flex x9 left align-center  d-flex>
                      {{statustoString(selectedAsset)}}
                </v-flex>
              </v-flex>
            </v-layout>
          </v-card>

          <!--
          <v-card color="red" class="white--text" v-if="asset.statusCode == 'ERROR'">
            <v-layout>
              <v-flex xs12 px-4 py-2 d-flex center>
                <v-flex d-flex><v-icon large color="red lighten-4">error</v-icon></v-flex>
                <v-flex x9 left align-center  d-flex>
                      Deze asset heeft een foutmelding
                </v-flex>
              </v-flex>
            </v-layout>
          </v-card>
          <v-card color="orange" class="white--text" v-if="asset.statusCode == 'WARNING'">
            <v-layout>
              <v-flex xs12 px-4 py-2 d-flex center>
                <v-flex d-flex><v-icon large color="orange lighten-4">error</v-icon></v-flex>
                <v-flex x9 left align-center  d-flex>
                      Deze asset heeft één of meerdere waarschuwing(en)
                </v-flex>
              </v-flex>
            </v-layout>
          </v-card>
          <v-card color="blue" class="white--text" v-if="asset.statusCode == 'ACTION'">
            <v-layout>
              <v-flex xs12 px-4 py-2 d-flex center>
                <v-flex d-flex><v-icon large color="blue lighten-4">build</v-icon></v-flex>
                <v-flex x9 left align-center  d-flex>
                      Deze asset heeft een openstaande acties
                </v-flex>
              </v-flex>
            </v-layout>
          </v-card>
          <v-card color="purple" class="white--text" v-if="asset.statusCode == 'ERROR_WITH_ACTION'">
            <v-layout>
              <v-flex xs12 px-4 py-2 d-flex center>
                <v-flex d-flex><v-icon large color="purple lighten-4">query_builder</v-icon></v-flex>
                <v-flex x9 left align-center  d-flex>
                      Deze asset heeft foutmelding met daarvoor een openstaande actie
                </v-flex>
              </v-flex>
            </v-layout>
          </v-card>
          -->
        </v-flex>
        <v-flex xs12 >          
            <v-layout >
              <v-flex xs12 px-4 py-2 d-flex center v-if="asset.tags">
                <div class="text-xs-center ">
                  <v-chip class="text-xs-center " color="lime" >Brandstof</v-chip>
                </div>
                <div class="text-xs-center">
                  <v-chip color="grey darken-2" textColor="white">Diesel</v-chip>
                </div>
                <div class="text-xs-center">
                  <v-chip color="blue lighten-1" d-flex>Vaste locatie</v-chip>
                </div>
                <div class="text-xs-center " >
                  <v-chip color="amber" d-flex>Vereist onderhoud</v-chip>
                </div>
              </v-flex>
              <v-flex style="text-align:center"  v-else py-3 d-flex>
                <h5><i>Geen tags aanwezig</i></h5>
              </v-flex>
            </v-layout>          
        </v-flex> 
        <v-flex xs12 >
          <v-expansion-panel expand >            
              <v-card color="grey lighten-3"  class="dd-expansion-panel no-shadow" flat >
                <v-card-text d-flex column>
                  <v-layout  class="layout" wrap row px-2>
                    <v-flex xs6 lg6  >
                      <div class="dd-label">Naam</div>
                      <div class="dd-value">{{selectedAsset.name}}</div>
                    </v-flex>
                    <v-flex xs6 lg6>
                      <div class="dd-label">Type</div>
                      <div class="dd-value">{{selectedAsset.type.name}}</div>
                    </v-flex>
                    <v-flex xs6 lg6>
                      <div class="dd-label">Groep</div>
                      <div class="dd-value">{{selectedAsset.group.name}}</div>
                    </v-flex>
                    <v-flex xs6 lg6>
                      <div class="dd-label">Locatie</div>
                      <div class="dd-value">{{((selectedAsset.street) ? selectedAsset.street : "Onbekende straat")}}, {{selectedAsset.city}}</div>
                    </v-flex>
                    <v-flex xs12 lg6>
                      <div class="dd-label">Opmerkingen</div>
                      <div class="dd-value">Geen opmerkingen</div>
                    </v-flex>
                     <v-flex xs12 lg6>
                      <div class="dd-label">Laatste positie verandering</div>
                      <div class="dd-value">{{ selectedAsset.positionUpdated }}</div>
                    </v-flex>
                    <v-flex xs12 lg6>
                      <template v-if="selectedAsset.batteryStatus">
                        <div class="dd-label">Batterijstatus</div>  
                        <div class="dd-value">                          
                          <div v-if="selectedAsset.batteryStatus == 'FULL'">Maximaal</div>                                                     
                          <div v-if="selectedAsset.batteryStatus == 'VERY_GOOD'">Zeer goed</div>
                          <div v-if="selectedAsset.batteryStatus == 'OK'">Voldoende</div>                                                     
                          <div v-if="selectedAsset.batteryStatus == 'LOW'" class="orange--text">Laag</div>
                          <div v-if="selectedAsset.batteryStatus == 'EMPTY'" class="red--text">Leeg</div>
                           
                          
                        </div>
                      </template>
                    </v-flex>
                    <v-flex xs12 lg6>
                      <div class="dd-label">Laatste update</div>
                      <div class="dd-value">{{ selectedAsset.lastSeen }}</div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <v-card color="grey lighten-3"  class="dd-expansion-panel no-shadow" flat v-if="selectedAsset.customFields" >
                <v-card-text d-flex column >
                  <v-layout  class="layout" wrap row px-2>
                    <v-flex xs6 lg6 v-for="customField of selectedAsset.customFields" :key="customField.name">                      
                      <div class="dd-label">{{customField.name}}</div>                    
                      <div class="dd-value" v-if="customField.typeInternal == 'onOff'">{{(customField.value == 1) ? 'Aan' : 'Uit'}}</div>
                      <div class="dd-value" v-else-if="customField.dataType == 'text'"> {{ customField.value }} </div>
                      <div class="dd-value" v-else-if="customField.typeInternal == 'yesNo'">{{(customField.value == 1) ? 'Ja' : 'Nee'}}</div>
                      <div class="dd-value" v-else-if="customField.decimals > 0">{{parseFloat(customField.value).toFixed(customField.decimals)}}{{customField.typeShort}}</div>
                      <div class="dd-value" v-else-if="customField.dataType == 'numeric'">{{parseInt(customField.value)}}{{customField.typeShort}}</div>                      
                      <div class="dd-value" v-else>{{customField.value}}{{customField.typeShort}}</div>
                    </v-flex>                    
                  </v-layout>
                </v-card-text>
              </v-card>            
              <v-card color=""  class="dd-expansion-panel no-shadow d-flex" flat v-if="selectedAsset.mappedData && selectedAsset.mappedData.length > 0">
                <v-card-text d-flex column>
                  <v-layout  class="layout" wrap row px-2 justify-center>
                    <v-flex xs12 lg6 v-for="data of selectedAsset.mappedData" :key="data.name" class='d-flex'>
                      <v-flex xs8>
                        <div class="dd-label" ><i :class="data.icon" class="accent--text pr-2"></i>{{data.name}} </div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="dd-value" v-if="data.typeInternal == 'onOff'">{{(data.value == 1) ? 'Aan' : 'Uit'}}</div>
                        <div class="dd-value" v-else-if="data.typeInternal == 'yesNo'">{{(data.value == 1) ? 'Ja' : 'Nee'}}</div>
                        <div class="dd-value" v-else-if="data.decimals > 0">{{parseFloat(data.value).toFixed(data.decimals)}}{{data.typeShort}}</div>
                        <div class="dd-value" v-else-if="data.dataType == 'numeric'">{{parseInt(data.value)}}{{data.typeShort}}</div>
                        <div class="dd-value" v-else>{{data.value}}{{data.typeShort}}</div>
                      </v-flex>                                            
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            
            <v-expansion-panel-content v-if="asset.timeSeries && asset.timeSeries.length > 0">
              <div slot="header">Datastromen</div>
              <time-serie-sparkline v-if="selectedTimeSerie" :serie="selectedTimeSerie.unitTypeTimeSerie" :serie-data="selectedTimeSerie" ></time-serie-sparkline>
              <v-flex grey lighten-3 px-4 v-if="timeSeries && timeSeries.length > 0">                
                <v-select 
                  item-text="text"                   
                  :items="timeSeries"
                  label="Meer data"
                  v-model="selectedTimeSerieId"
                ></v-select>

              </v-flex>
            </v-expansion-panel-content>
                       
            <v-expansion-panel-content>
             <!-- <div slot="header">Laatste acties <v-chip  small>{{((selectedActions) ? selectedActions.length : 0)}}</v-chip></div> -->
              <!-- <v-card flat v-if="selectedActions">
                <template>
                  <v-data-table
                    :hide-headers="true"
                    :items="selectedActions"
                    hide-actions
                    class="elevation-0 table-striped"
                    style="border-top: 1px #ccc solid"                                        
                  >
                    <template slot="items" slot-scope="event" >
                      <tr :style="`background-color: ${actionStatusColor(event.item)}`" class=" lighten-2 " >                    
                        <td class="text-xs-left py-2">{{ event.item.eventAction.name }}</td>
                        <td class="text-xs-left py-2">{{ event.item.creationDate | date_nl }}</td>
                        <td style="width:50px;">
                          <div class="action-row-buttons py-2"> 
                            <v-tooltip left>
                              <v-btn  flat icon  :style="`color: rgba(0,0,0,0.4);`" slot="activator" @click="executeActionClicked(event.item)" v-if="event.item.status.internalName == 'open'">
                                <v-icon >edit</i>
                              </v-btn>
                              <span>Voer actie uit</span>
                            </v-tooltip>                                          
                            <v-tooltip left>
                              <v-btn  flat icon  :style="`color: rgba(0,0,0,0.4);`" slot="activator" @click="cancelActionClicked(event.item)" v-if="event.item.status.internalName == 'open'">
                                <v-icon >cancel</v-icon>
                              </v-btn>
                              <span>Annuleer actie</span>
                            </v-tooltip>
                            <v-tooltip left>
                              <v-btn  flat icon  :style="`color: rgba(0,0,0,0.4);`" slot="activator" @click="infoActionClicked(event.item)" v-if="event.item.status.internalName != 'open'">
                                <v-icon >info</v-icon>
                              </v-btn>
                              <span>Bekijk actie</span>
                            </v-tooltip>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </template>
              </v-card> -->
            </v-expansion-panel-content>
            <v-expansion-panel-content>
              <div slot="header">Logboek <v-chip  small>{{((selectedEventsMeta) ? selectedEventsMeta.pagination.total : 0)}}</v-chip></div>
              <v-card flat v-if="selectedAsset">       
                <dossier-log-book 
                    :asset="selectedAsset"
                    :perPage="8"
                >
                </dossier-log-book>               
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>        
      </v-layout> 
      <asset-user-favorite  v-if="favoritePannelOpen"       
        :favorite="isFavorite" 
        :assetId="selectedAsset.id" 
        @favoriteSaved="favoriteSaved()"
        @panelClosed="favoritePannelOpen=false"        
      >
      </asset-user-favorite>         
    </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import * as types from "../../store/types"
import ColorMixin from "../../plugins/mixins/ColorMixin"
import AssetMixin from "../../plugins/mixins/AssetMixin"
import DossierLogBook from "../../components/event/DossierLogBook"   
import AssetUserFavorite from "../../components/asset/AssetUserFavorite"
import TimeSerieSparkline from './TimeSerieSparkline'
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { MAP_URL, IMAGE_URL } from "../../config.js";

export default{
  components:{
    TimeSerieSparkline,
    VuePerfectScrollbar,
    AssetUserFavorite,
    DossierLogBook
  },
  props:['asset'],  
  mixins: [ColorMixin, AssetMixin],
  data(){
    return {      
      favoritePannelOpen:false,
      showGeneral: true,
      items: [ 'test','test 2' ],
      selectedTimeSerieId: null,
      scrollSettings: {
        maxScrollbarLength: 160,
        suppressScrollX: true
      },
      eventPage: 1
    }
  },
  computed:{
    ...mapGetters({    
        selectedTimeSerie: types.ASSET_TIME_SERIE,
        selectedAsset: types.ASSET,
        searchTerm: types.GLOBAL_SEARCH_TERM,
        selectedEvents: types.ASSET_PROCESSED_EVENTS,
        selectedEventsMeta: types.ASSET_PROCESSED_EVENTS_META,
        selectedActions: types.ASSET_PROCESSED_ACTIONS,
        currentUser: types.CURRENT_USER,
        userFavoriteAssets: types.USER_FAVORITE_ASSETS, 
    }),
    imageUrl(){

      return `${IMAGE_URL}/${this.selectedAsset.mainImage.publicLocation}`;
    },
    //TODO: Temp function for Tata Steel Users, remove when normal rights system is active
    visibleForUser(){    
        
        let found = this.currentUser.roles.find((role) => {
            return role.name == "Tata Steel Gebruiker" ? true : false
        })

        // dont show item if user is member of Tata Steel User
        return found ? false : true;
    },
    defaultTimeSerie(){      
      if(!this.selectedAsset.timeSeries)
        return false

      let res = this.selectedAsset.timeSeries.find((ele) => {
          return ele.isPrimary == true
      })      
      return res;
    },
    isFavorite(){
        let vm = this      
        return this.userFavoriteAssets.find((favorite) => {
            return (favorite.assetId == vm.selectedAsset.id)  ? favorite : null
        })
    },
    favoriteClass(){
      return this.isFavorite && this.isFavorite.active ?  "fas fa-star" : "far fa-star"
    },
    timeSeries(){

      let ts =  this.selectedAsset.timeSeries.map((ele) => {        
        //return ele.name
        return {text: ele.name, value: ele.id}
      })
      return (ts !== null) ? ts : []
    },
    processedEventTableHeaders(){
      return [
        {
          text: '',
          // value: string
          align: 'center',
          sortable: false,
          // class: string[] | string
          width: '38px'
        },       
        
        {
          text: 'Omschrijving',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tijd',
          align: 'left',
          sortable: false
        },
        {
          text: 'Datum',
          align: 'left',
          sortable: false,
          width: '150px'
        }
      ]
    },
  },
  watch: {
    asset: {
      handler(){        

        let serie = this.defaultTimeSerie      
        if(serie && serie.id){
          this.$store.dispatch(types.ASSET_TIME_SERIE,null)
          this.$nextTick( () => {

            this.$store.dispatch(types.ASSET_TIME_SERIE, {data: {assetId: this.selectedAsset.id, timeSerieId: serie.id}, params:{include: 'unitTypeTimeSerie'}})            
            this.selectedTimeSerieId = serie.id
          })
        }
        else{
          this.$store.dispatch(types.ASSET_TIME_SERIE, null)
        }
          
        this.eventPage = 1

        //this.$store.dispatch(types.ASSET_PROCESSED_EVENTS, {data: {id: this.selectedAsset.id},  params:{per_page: 10, include:'unitTypeEvent.eventSeverity,unitTypeEvent.eventType,unitTypeEvent.eventActions'}})
        this.$store.dispatch(types.ASSET_PROCESSED_ACTIONS, {data: {id: this.selectedAsset.id}, params:{per_page: 10, include:'status,concludedBy,processedEvent.unitTypeEvent,eventAction.doneEvent,eventAction.cancelEvent'}}).then(() => {
        })
      },
      immediate: true
    },
    selectedTimeSerieId(newId){
      this.$store.dispatch(types.ASSET_TIME_SERIE, {data: {assetId: this.selectedAsset.id, timeSerieId: newId}, params:{include: 'unitTypeTimeSerie'}})
    }
  },
  methods:{   
    openFavoritePannel(){
      this.favoritePannelOpen=true      
    },
    favoriteSaved(){
      this.favoritePannelOpen=false    
    },
    // clear(){
    //   this.$store.dispatch(types.ASSET_PROCESSED_EVENTS, null)
    //   this.$store.dispatch(types.ASSET_TIME_SERIE, null)
    // },
    discardable(event){      
      if(event.messageType.internalName == 'error'){
        
          return true
        
      }
      
    },
    actionStatusColor(action){      
      if(action.status.internalName == "open"){
        return this.infoColor;
      }
      if(action.status.internalName == "done"){
        return this.successColor;
      }
      if(action.status.internalName == "cancelled"){
        return this.errorColor;
      }
    },
    colorForEventType(internalName){      
      switch(internalName) {
        case 'success':
          return this.successColor;
        case 'error':
          return this.errorColor;
        case 'info':
          return this.infoColor;
        case 'warning':
            return this.warningColor;
        default :
          return '#ccc';
      }
    },
    loadFavorites(){
      this.$store.dispatch(types.USER_FAVORITE_ASSETS,{data:{"userId":this.currentUser.id },params:{per_page:200, include:"asset"}})      
    },
    changeEventPage(){
      
      this.$store.dispatch(types.ASSET_PROCESSED_EVENTS, {data: {id: this.selectedAsset.id}, params: {per_page: 10, page:this.eventPage, include: 'itemType,event.eventType, event.eventSeverity'}})
    },
    cancelActionClicked(action){
      this.$emit('cancelActionClicked', action)
    },
    executeActionClicked(action){
      this.$emit('executeActionClicked', action)
    },
    infoActionClicked(action){
      this.$emit('infoActionClicked', action)
    },
    infoEventClicked(event){
      this.$emit('infoEventClicked', event)
    },
    createManualEventClicked(asset){
      this.$emit('createManualEventClicked', asset)
    },
    assetConfigurationClicked(asset){
      this.$emit('assetConfigurationClicked', asset)
    },
    showPOIWizard(asset){
      this.$emit('assetPoiWizardClicked', asset)      
    }    
  },
  mounted(){
    this.loadFavorites()
  }
  
}
</script>
<style>

  .map-asset-details-container{
    margin-top:0px !important;
    background-color: #fff;
    max-width: 600px !important;
    overflow-x: hidden;
    
    height: calc(100vh - 60px);
  }

    .map-asset-list-container{
    margin-top:0px !important;
    background-color: #fff;
    max-width: 300px !important;
    overflow-x: hidden;
    
    height: calc(100vh - 60px);
  }

  .asset-icon{
    font-size: 60px;

    opacity: 0.2;
    margin-right: 14px;
  }

  .close-card{
    position: absolute !important;
    right: 0;
    top:0;
    margin-top: 10px !important;
  }



  

  .dd-expansion-panel{
    border-top: 1px solid #777 !important;
    border-bottom: 1px solid #777 !important;
    width: 100%;
    display: flex !important;
    justify-content: center !important;
  }

  .scrollbar{
    overflow-y: auto !important;
  }

  .action-row-buttons{
    display: flex;
  }

  .asset-heading-image{    
    background-size: cover !important;
    background-clip: border-box;
  
    opacity: 0.9;
    min-height: 280px;
    display: flex !important;    
    justify-content: flex-start;
    align-content:flex-end;
    align-items:flex-end;
    background-color: #2c3e50;
  }

  .asset-image-info{
    background-color:rgba(44,62,80,0.8) !important;
    margin: 0px 0px;
    position: absolute;
    width: 100%;
    justify-content:space-around;
    border-radius: 5px !important;
    padding: 4px 2px !important;
    height: 30px;
    display: flex;
    
  }

  .asset-image-info fas{
   color: rgba(0,0,0,0.8) !important;
  }

  .asset-details-close-button{
    position: absolute;
    right: 0;
    top: 0;
    margin-top: 14px;
    margin-right: 14px;
  }
</style>
